import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Icon from '../../../elements/Icon';
import Text from '../../../elements/Text';
import Button from '../../../elements/Button';

const FareItemNoPriceAvailable = (props) => {
  const {
    onClick,
    onKeyDown,
    message,
    iconStyles,
    textIconStyles,
    messageStyles,
    linkAvailabilityStyles,
    showIcon,
    showMessage,
    showLinkAvailability,
    tabIndex,
    notShowAsLink = false,
    labelKey = 'cmp-day-card-no-price-link'
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const label = translate(labelKey, 'Check Availability');

  const handleClick = (e) => onClick(e, label);
  const handleKeyDown = (e) => onKeyDown(e, label);
  const Tag = notShowAsLink ? Text : Button;

  return (
    <Box
      display="flex"
      flexDirection="column"
      textAlign="center"
      marginTop="auto"
      className={className}
      style={style}
    >
      {showIcon && (
        <Text margin="0" {...textIconStyles}>
          <Icon icon="search" {...iconStyles} />
        </Text>
      )}
      {showMessage ? (
        <Text {...messageStyles}>{translate(message, 'No available results')}</Text>
      ) : (
        <Text className="fr-sr-only">{translate(message, 'No available results')}</Text>
      )}
      {showLinkAvailability && (
        <Tag
          color="link"
          ariaLabelInFocus
          {...linkAvailabilityStyles}
          dataReactCmpOwner="checkAvailabilityCallToAction"
          tabIndex={tabIndex ? null : -1}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          ariaLabel={notShowAsLink ? null : label}
        >
          {label}
        </Tag>
      )}
    </Box>
  );
};

FareItemNoPriceAvailable.propTypes = {
  /**
   * message to show
   */
  message: PropTypes.string,
  /**
   * Props of the icon
   */
  iconStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of the text icon
   */
  textIconStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of the message
   */
  messageStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of the linkAvailabilityStyles
   */
  linkAvailabilityStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the showIcon section
   */
  showIcon: PropTypes.bool,
  /**
   * Turn off or on the showMessage section
   */
  showMessage: PropTypes.bool,
  /**
   * Turn off or on the showLinkAvailability section
   */
  showLinkAvailability: PropTypes.bool,
  /**
   * Event fired when clicked check availability link
   */
  handleClick: PropTypes.func,
  /**
   * Call to action onClick event
   */
  onClick: PropTypes.func,
  /**
   * Call to action onKeydown event
   */
  onKeyDown: PropTypes.func,
  /**
   * Define if the callToAction will have focus for Screen Readers
   */
  tabIndex: PropTypes.bool
};

FareItemNoPriceAvailable.defaultProps = {
  message: 'cmp-day-card-no-price',
  iconStyles: {},
  textIconStyles: {},
  messageStyles: {},
  linkAvailabilityStyles: {},
  showIcon: true,
  showMessage: true,
  showLinkAvailability: false,
  handleClick: () => {},
  onClick: () => {},
  onKeyDown: () => {},
  tabIndex: true
};

FareItemNoPriceAvailable.componentName = 'FareItemNoPriceAvailable';

export default FareItemNoPriceAvailable;
